import contract from '@mailobj-browser/front/js/contracts/contract.js'
import expandable from './expandable/expandable.js'

export default contract({
  expandable,
})
